<template>
  <el-dialog :title="noticeFirst.title" :visible="true" @close="noticeClose">
    <div v-html="noticeFirst.content" class="dialog-notice-div"></div>
  </el-dialog>
</template>

<script>
import {getOneNoticeInfo} from "@/assets/request/SelfOperatedMall/SelfOperatedMallRequest";
import { queryNoticeDetailRequest } from '@/assets/request/HomeRequest';
import {Message, MessageBox} from "element-ui";
import {showLoading, hideLoading} from '@/js/loading';
export default {
  name: "noticeDetail",
  data(){return{
    noticeFirst:{},
  }},
  props:{
    id:{
      type:Number,
      default:0
    },
    noticeType:{
      type:Number,
      default: 0,
    },
  },
  methods:{
    noticeClose(){
      this.$emit('close');
    }
  },
  created() {
    if(this.noticeType===0){
      getOneNoticeInfo(this.$props.id).then(r=>{
        if(r.status!==200 || r.data.code!=200) return;
        this.noticeFirst=r.data.data;
      })
    }
    else if(this.noticeType===1){
      showLoading();
      queryNoticeDetailRequest(this.$props.id).then(r=>{
        if(r.status!==200) return hideLoading(),Message.warning(r.statusText);
        const {data} = r;
        console.log(data);
        this.noticeFirst=data;
        hideLoading();
      }).catch(r=>{
        hideLoading();
        const message = '查看详情失败';
        Message.error(message);
        console.trace({ message,r });
      });
    }

  }
}
</script>

<style scoped lang="scss">
.dialog-notice-div{
  ::v-deep img{
    width: 100%;
  }
}
</style>